export type Testimonial = {
  quote: string
  name: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'The visual structure makes it much easier to explain partnerwork, turns and progression without overcomplicating the class.',
    name: 'Daniel Foster',
    role: 'Salsa & Bachata Instructor',
    location: 'Miami, USA',
  },
  {
    quote:
      'I really like having Salsa, Bachata, partnerwork and class progression organized in one place. It makes planning much faster.',
    name: 'Camila Torres',
    role: 'Latin Dance Instructor',
    location: 'Madrid, Spain',
  },
  {
    quote:
      'The ready-to-teach classes give me a clear starting point, and the visual breakdowns help me explain movements more consistently to my students.',
    name: 'Marco Bennett',
    role: 'Salsa & Bachata Teacher',
    location: 'London, UK',
  },
]
